import { EBrandedIconShapeColor } from '@spinwise/react-component-library/BrandedIcon';
import {
  closeNotification,
  getBonusRandomReplayListNotSelected,
  IApplicationState,
  IBonusWheelBonusRandomReplay,
  IBonusWheelBonusReplayListPromo,
  IBonusWheelBonusReplayListResponseData,
  IWheelReducerWheelSpinNow,
  postBonusRandom,
  resetReplayListNotSelected,
  resetWheelDepositBonus,
  setLanguage,
  setWheelNotificationBonus,
} from '@spinwise/spinwise-core';
import classNames from 'classnames';

import { getOverlayNoBonusWheel } from 'Components/_brand/overlays/brandOverlaysLibrary';
import { t } from 'i18next';
import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { basicChannel } from 'src/channels/basic.channel';
import { EBrandIconIconPathShared, EBrandIconStatusPathShared } from 'src/libraryShared/icons';
import { amountToCurrency } from 'Utils/index';
import styles from './WheelBonusIframe.module.scss';
import { ETitleBarHierarchy, TitleBar } from '@spinwise/react-component-library/TitleBar';
import { EWheelBundleImages, EWheelImages, WHEEL_PRIZE_DATA } from './types';
import { WinLayout } from './WheelWinLayout/WheelWinLayout';
import { WheelDescriptionBanner } from './WheelDescriptionBanner/WheelDescriptionBanner';

interface IIframeData {
  id: string;
  count: string;
  image: string;
}
interface IIframeContent {
  filesPath: string;
  megaWin: string;
  spinButton: string;
  data: Array<IIframeData>;
}
export enum EWheelBonusOverlays {
  WARNING_HAS_ACTIVE_BONUS = 'warning-has-active-bonus',
  ACTIVATE_BONUS = 'activate-bonus',
  WARNING_ACTIVATE_LATER = 'warning-activate-later',
  HAS_LUCKY_WHEEL_BONUS = 'has-lucky-wheel-bonus',
}
export enum EWheelBonusOverlayStorage {
  POPUP_NAME = 'wheel-bonus-popup',
  POPUP_TYPE = 'wheel-bonus-type-popup',
}
export interface EWheelBonusPopupType {
  type: 'money' | 'else' | EWheelImages.JACKPOT;
  amount: string;
  bonusName: string;
  game: string;
  bonusEid: string;
  free_rounds?: {
    game: {
      urlKey: string;
      name: string;
    };
  };
}
export enum EWheelState {
  LOADING,
  WHEEL,
  SPIN,
  RESULT,
  NO_REPLAY,
  ERROR,
}

/**
 * 1 - Get replay list
 * 2 - map BE data
 * 3 - start loading iframe
 *
 */
export const WheelBonusIframe = ({ luckyWheelUrl }: any) => {
  // check user BONUS_RNDM notification
  const accountCurrencyCode = useSelector(
    (state: IApplicationState) => state.accountReducer.info?.balance?.currency?.code,
  );
  const wheelSpinNow = useSelector((state: IApplicationState) => state.wheelReducer.wheelSpinNow);

  const accountId = useSelector((state: IApplicationState) => state.accountReducer.info?.id);
  const wheelMainContainerRef = useRef<HTMLDivElement>();
  const router = useRouter();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const dispatch = useDispatch();
  const languagesList = useSelector((state: IApplicationState) => state.globalReducer.languages?.data);

  const languagesLoading = useSelector((state: IApplicationState) => state.globalReducer.languages?.loading);
  const languagesSuccess = useSelector((state: IApplicationState) => state.globalReducer.languages?.success);

  const [winSection, setWinSection] = useState<{
    eid;
    image;
    imageBE;
    count;
    game;
    free_rounds?: any;
    coefficient?: string;
  }>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [wheelState, setWheelState] = useState(EWheelState.LOADING);
  /**selected = false, activated = false */
  const [bundleResponse, setBundleResponse] = useState<{
    success: boolean;
    replay_eid?: string;
    selected_bundle_eid?: string;
    wheelData?: {
      data: Array<{ id; count; image; game; free_rounds?: any; coefficient?: any }>;
      megaWin: string;
      filesPath: string;
      spinButton: string;
    };
  }>(null);
  const [currentPromo, setCurrentPromo] = useState<IBonusWheelBonusReplayListPromo>(null);

  // #region Supports functions

  const getAmountFromBonusData = (bundle: any): string => {
    const image = bundle.image as keyof typeof WHEEL_PRIZE_DATA;
    let result = '?';
    switch (image) {
      case EWheelBundleImages.JACKPOT:
      case EWheelBundleImages.CASHBACK:
      case EWheelBundleImages.REAL_MONEY:
        result = bundle?.data?.bonus_value;
        break;
      case EWheelBundleImages.MEGA_SPINS:
      case EWheelBundleImages.SUPER_FREE_SPINS:
      case EWheelBundleImages.FREE_SPINS:
        result = bundle?.data?.free_rounds?.count;
        break;
      case EWheelBundleImages.GAME:
        result = bundle?.data?.free_rounds?.in_game_bonus_value;
        break;
    }
    return result?.toString();
  };
  /**Example: transfrorm EWheelImages.GAME to 'wheel-game.png' */
  const getBEimageByWheelImage = (image: any): keyof typeof WHEEL_PRIZE_DATA => {
    return (
      (Object.keys(WHEEL_PRIZE_DATA).find(k => WHEEL_PRIZE_DATA[k].image === image) as keyof typeof WHEEL_PRIZE_DATA) ??
      (EWheelBundleImages.MEGA_SPINS as keyof typeof WHEEL_PRIZE_DATA)
    );
  };
  const getWinWager = (key: keyof typeof WHEEL_PRIZE_DATA, coefficient: any = 0): number | undefined => {
    if (coefficient <= 0) return undefined;

    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.CASHBACK) return coefficient;
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.JACKPOT) return coefficient;

    return undefined;
  };
  const getWinAmount = (key: keyof typeof WHEEL_PRIZE_DATA, amount = ''): string => {
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.JACKPOT)
      return amountToCurrency(amount, accountCurrencyCode)?.replaceAll(' ', '');
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.CASHBACK)
      return amountToCurrency(amount, accountCurrencyCode)?.replaceAll(' ', '');
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.REAL_MONEY)
      return amountToCurrency(amount, accountCurrencyCode)?.replaceAll(' ', '');
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.GAME)
      return amountToCurrency(amount, accountCurrencyCode)?.replaceAll(' ', '');

    return amount;
  };
  const getWinType = (key: keyof typeof WHEEL_PRIZE_DATA): 'money' | EWheelImages.JACKPOT | 'else' => {
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.JACKPOT) return EWheelImages.JACKPOT;
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.CASHBACK) return 'money';
    if (WHEEL_PRIZE_DATA[key].image == EWheelImages.REAL_MONEY) return 'money';

    return 'else';
  };

  /**fix ios < 16, where dvh doesn't support */
  const fix100vh = () => {
    if (!wheelMainContainerRef?.current) return;
    if (window?.innerWidth >= 767) {
      wheelMainContainerRef.current.style.height = '';
      return;
    }
    wheelMainContainerRef.current.style.height = window.innerHeight + 'px';
  };
  // #endregion
  useEffect(() => {
    // set language
    if (languagesLoading === false && languagesSuccess) {
      const language = languagesList?.filter((lang: any) => lang.code === router?.locale) as any;
      setLanguage(language[0]?.code, language[0]?.name)(dispatch, {});
    }
  }, [dispatch, router.locale, languagesLoading, languagesSuccess, languagesList]);

  const setNoReplay = () => {
    setWheelState(EWheelState.NO_REPLAY);
    resetReplayListNotSelected()(dispatch);
    setWheelNotificationBonus(null)(dispatch);
    getOverlayNoBonusWheel({
      title: t('wheel.popup.no.bonus.title'),
      description: t('wheel.popup.no.bonus.description'),
      icon: {
        shapeColor: EBrandedIconShapeColor.Default,
        statusPath: EBrandIconStatusPathShared.FAILED,
        iconPath: EBrandIconIconPathShared.BonusWheelWheel,
      },
      button: {
        text: t('wheel.popup.no.bonus.button'),
        onClickEvent: () => {
          basicChannel.send({
            action: 'close',
          });
          router.replace(PATHS.LOBBY);
        },
      },
    });
  };
  const checkReplayList = () => {
    getBonusRandomReplayListNotSelected()(dispatch).then((res: IBonusWheelBonusReplayListResponseData) => {
      const findReplay = (data: IWheelReducerWheelSpinNow): IBonusWheelBonusRandomReplay => {
        switch (data?.type) {
          case 'replay':
            return res?.random_replay.find(rr => rr.replay_eid === wheelSpinNow?.id);
          case 'notification':
            return res?.random_replay.find(rr => rr.notify_eid === wheelSpinNow?.id);
          default:
            return res?.random_replay?.[0];
        }
      };

      const random_replay = findReplay(wheelSpinNow);

      const promo = random_replay?.promo?.[0];
      if (promo) {
        setCurrentPromo(promo);
        setBundleResponse({
          success: true,
          replay_eid: random_replay.replay_eid,
          selected_bundle_eid: random_replay.selected_bundle_eid,
          wheelData: {
            spinButton: t('wheel.page.spin.button'),
            filesPath: '620b7f4b93b52136d0a2b520/v1', //t('620b7f4b93b52136d0a2b520/default')
            megaWin: t('wheel.page.mega.win', '€5000'),
            data: promo.bundles?.map(b => {
              return {
                id: b.eid,
                count: getWinAmount(b.image as any, getAmountFromBonusData(b)),
                image: WHEEL_PRIZE_DATA[b.image].image ?? WHEEL_PRIZE_DATA[EWheelBundleImages.MEGA_SPINS]?.image,
                game: b?.data?.free_rounds?.game?.name,
                free_rounds: b?.data?.free_rounds,
                coefficient: getWinWager(b.image as any, b?.coefficient),
              };
            }),
          },
        });
        setWheelState(EWheelState.WHEEL);
      } else {
        setNoReplay();
      }
    });
  };
  useEffect(() => {
    switch (wheelSpinNow?.type) {
      case 'notification':
        closeNotification(
          wheelSpinNow?.id,
          'accept',
        )(dispatch).then(response => {
          setWheelNotificationBonus(null)(dispatch);
          checkReplayList();
        });
        break;
      case 'replay':
        checkReplayList();
        break;
      default:
        setNoReplay();
        break;
    }

    const handleOrientationChange = () => {
      if (!iframeRef?.current) return;
      iframeRef.current.style.height = 'auto';

      setTimeout(() => {
        if (!iframeRef?.current) return;
        iframeRef.current.style.height = '100%';
      }, 300);
    };
    // Run initially
    handleOrientationChange();

    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', fix100vh);
      window.removeEventListener('message', handleWheelEvents);
    };
  }, []);

  useEffect(() => {
    if (bundleResponse && iframeRef.current && iframeRef.current.contentWindow)
      window.addEventListener('message', handleWheelEvents);
  }, [bundleResponse, iframeRef]);

  const handleWheelEvents = (
    event: MessageEvent<{ type: string; content: string | { id: string; count: string; image: string } }>,
  ) => {
    // Validate the origin of the message
    // if (event.origin !== wheel_host && event.origin !== window.location.origin) {
    //     setWheelState(EWheelState.ERROR);
    //     setIframeLoaded(true);
    //     return;
    // }
    if (!iframeRef || !iframeRef.current) return;

    switch (event.data.type) {
      case 'IFRAME_READY':
        // Send a message to the iframe when the button is clicked
        const content: IIframeContent = {
          ...bundleResponse?.wheelData,
        };
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: 'INIT',
            content: {
              distinctId: accountId,
            },
          },
          '*',
        );
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: 'BUNDLE_DATA',
            content: content,
          },
          '*',
        );

        break;
      case 'WHEEL_SCENE_READY':
        setIframeLoaded(true);
        break;
      case 'WHEEL_START':
        // remove lobby banner
        resetWheelDepositBonus()(dispatch);
        resetReplayListNotSelected()(dispatch);
        setWheelNotificationBonus(null)(dispatch);
        const { replay_eid } = bundleResponse;
        //the bonus has already been selected
        setWheelState(EWheelState.SPIN);
        if (wheelState != EWheelState.SPIN)
          postBonusRandom(
            replay_eid,
            'select',
          )(dispatch).then(data => {
            const eid = data.selected_bundle_id;
            const bundle = bundleResponse.wheelData.data.find(el => el.id == eid);
            const imageBE = getBEimageByWheelImage(bundle?.image);

            if (!eid) {
              localStorage.removeItem(EWheelBonusOverlayStorage.POPUP_NAME);
              localStorage.removeItem(EWheelBonusOverlayStorage.POPUP_TYPE);
              router.reload();
              return;
            }

            setWinSection({
              eid: eid,
              count: bundle?.count,
              image: bundle?.image,
              imageBE: imageBE,
              game: bundle?.game,
              free_rounds: bundle?.free_rounds,
              coefficient: bundle?.coefficient,
            });

            localStorage.setItem(EWheelBonusOverlayStorage.POPUP_NAME, EWheelBonusOverlays.WARNING_ACTIVATE_LATER);

            let storageBonus: EWheelBonusPopupType = {
              bonusName: t(WHEEL_PRIZE_DATA[imageBE].name),
              amount: bundle?.count,
              type: getWinType(imageBE),
              game: bundle?.game ?? '',
              bonusEid: bundleResponse.replay_eid,
              free_rounds: bundle?.free_rounds,
            };
            localStorage.setItem(EWheelBonusOverlayStorage.POPUP_TYPE, JSON.stringify(storageBonus));

            iframeRef.current?.contentWindow?.postMessage(
              {
                type: 'WINNER_ID',
                content: eid, //winSection.selected_bundle_eid
              },
              '*',
            );
          });

        break;
      case 'SHOW_WIN_LAYOUT':
        setWheelState(EWheelState.RESULT);
        break;
      case 'WHEEL_ERROR':
        setWheelState(EWheelState.ERROR);
        break;
    }
  };

  const winLayout = useMemo(() => {
    return wheelState === EWheelState.RESULT ? <WinLayout winSection={winSection} /> : null;
  }, [wheelState]);

  const hideUiOnSpin = () => {
    if (wheelState == EWheelState.SPIN) return styles.hide_ui;
    return '';
  };

  return (
    <div ref={wheelMainContainerRef} className={styles.wheel_bonus}>
      {iframeLoaded ? (
        <>
          <div className={styles.bg1}>
            <div className={classNames(styles.banner_container, hideUiOnSpin())}>
              {currentPromo ? <WheelDescriptionBanner bundles={currentPromo?.bundles} /> : null}
            </div>
          </div>
          <div className={classNames(styles.cross_container, hideUiOnSpin())}>
            <TitleBar
              hierarchy={ETitleBarHierarchy.Secodnary}
              iconTrailing={true}
              iconLeading={false}
              onClickCloseEvent={() => router?.push(PATHS.LOBBY)}
            />
          </div>
          <div className={classNames(styles.title_container, hideUiOnSpin())}>
            <p className={styles.page_title}>{t('wheel.page.title')}</p>
          </div>
        </>
      ) : (
        <div>
          <img className={styles.loading_element} src="/images/main-loading.svg" alt="" />
        </div>
      )}

      {wheelState != EWheelState.LOADING && wheelState != EWheelState.NO_REPLAY && wheelState != EWheelState.ERROR ? (
        <iframe
          key={`iframe_loaded_${iframeLoaded}`}
          width="100%"
          height="100%"
          sandbox="allow-scripts allow-same-origin "
          allow="webgl; fullscreen; autoplay; accelerometer;display-capture"
          className={styles.iframe_element}
          style={{
            opacity: iframeLoaded ? 1 : 0,
            border: 'none',
            willChange: 'transform',
            aspectRatio: '9 / 16',
          }}
          ref={iframeRef}
          src={`/lucky-wheel`}
        />
      ) : null}
      {winLayout}
    </div>
  );
};
export default WheelBonusIframe;
